export default "__VITE_ASSET__a33fe22a__"